export default __webpack_public_path__ + "static/encode-denver-93b4a57cbc3fc9d31f56a20734fd568d.jpeg";